const translateHeadingLabel = (label, isSpanishLocale) => {
  const match = label.match(/^Make this a heading (\d)$/i);
  if (!match) return null;

  return isSpanishLocale
    ? `Convertir en encabezado ${match[1]}`
    : `Make this a heading ${match[1]}`;
};

export const translateEditorToolbarLabel = (label, locale = 'en') => {
  if (!label) return label;

  const normalizedLabel = `${label}`.trim();
  const isSpanishLocale = `${locale}`.toLowerCase().startsWith('es');

  const headingLabel = translateHeadingLabel(normalizedLabel, isSpanishLocale);
  if (headingLabel) return headingLabel;

  const translations = {
    'Toggle strong style': {
      en: 'Toggle bold',
      es: 'Alternar negrita',
    },
    'Toggle emphasis': {
      en: 'Toggle italic',
      es: 'Alternar cursiva',
    },
    'Toggle emphasis style': {
      en: 'Toggle italic',
      es: 'Alternar cursiva',
    },
    'Toggle code font': {
      en: 'Toggle code',
      es: 'Alternar codigo',
    },
    'Toggle code style': {
      en: 'Toggle code',
      es: 'Alternar codigo',
    },
    'Toggle strike through': {
      en: 'Toggle strikethrough',
      es: 'Alternar tachado',
    },
    'Add or remove link': {
      en: 'Add or remove link',
      es: 'Agregar o quitar enlace',
    },
    'Insert image': {
      en: 'Insert image',
      es: 'Insertar imagen',
    },
    'Wrap in bullet list': {
      en: 'Wrap in bullet list',
      es: 'Convertir en lista con vinetas',
    },
    'Wrap in ordered list': {
      en: 'Wrap in ordered list',
      es: 'Convertir en lista numerada',
    },
    'Wrap in block quote': {
      en: 'Wrap in block quote',
      es: 'Convertir en cita',
    },
    'Wrap in blockquote': {
      en: 'Wrap in block quote',
      es: 'Convertir en cita',
    },
    'Change to paragraph': {
      en: 'Change to paragraph',
      es: 'Convertir en parrafo',
    },
    'Insert horizontal rule': {
      en: 'Insert horizontal rule',
      es: 'Insertar separador horizontal',
    },
    'Undo last change': {
      en: 'Undo last change',
      es: 'Deshacer ultimo cambio',
    },
    'Redo last change': {
      en: 'Redo last change',
      es: 'Rehacer ultimo cambio',
    },
  };

  return translations[normalizedLabel]?.[isSpanishLocale ? 'es' : 'en'] || label;
};

export const localizeEditorToolbar = (rootElement, locale = 'en') => {
  if (!rootElement?.querySelectorAll) return;

  rootElement.querySelectorAll('[title], [aria-label]').forEach(element => {
    ['title', 'aria-label'].forEach(attributeName => {
      const attributeValue = element.getAttribute(attributeName);
      if (!attributeValue) return;

      const translatedValue = translateEditorToolbarLabel(
        attributeValue,
        locale
      );

      if (translatedValue !== attributeValue) {
        element.setAttribute(attributeName, translatedValue);
      }
    });
  });
};
